
























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { usersService, businessOrdersService, authorizationManagerService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessOrder } from '@/models/orders/business-order';
import { PaymentMethod } from '@/models/common/payment-method';
import { mdbTbl, mdbTblBody, mdbRow, mdbCol, mdbCard, mdbCardText, mdbCardBody, mdbCardTitle, mdbCardHeader, mdbView, mdbTooltip, mdbBtn } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbTbl,
        mdbTblBody,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardText,
        mdbCardBody,
        mdbCardTitle,
        mdbCardHeader,
        mdbView,
        mdbTooltip,
        mdbBtn,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessOrderDetailsView extends Vue {
    private businessOrder: BusinessOrder = new BusinessOrder();

    private pageContentLoaded: boolean = false;

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.orders.businessOrderDetailsView.headerTitle');
        this.businessOrder = await businessOrdersService.getBusinessOrder(+this.$route.params.id);

        if (authorizationManagerService.isBusinessOwner(this.businessOrder.businessId) && !this.businessOrder.viewed) {
            await businessOrdersService.updateBusinessOrderViewed(this.businessOrder.id, this.businessOrder.businessId, true);
            this.$root.$emit('order-viewed');
        }

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.BusinessOrders,
                scope: UserActionScopeType.Details,
                entityId: this.businessOrder.id
            })
        );
        setTimeout(() => this.switchPageContentToLoaded(), 10);
    }

    private switchPageContentToLoaded() {
        this.pageContentLoaded = true;
    }

    private getPaymentInfo(): string {
        if (this.businessOrder.paymentMethod !== null && this.businessOrder.paymentMethod !== undefined) {
            const toStringCamelCase = (str: string) => {
                return str
                    .replace(/\s(.)/g, ($1: string) => $1.toUpperCase())
                    .replace(/\s/g, '')
                    .replace(/^(.)/, ($1: string) => $1.toLowerCase());
            };

            return this.$t(`views.orders.businessOrderDetailsView.payment.info.${toStringCamelCase(PaymentMethod[this.businessOrder.paymentMethod!])}`).toString();
        }
        return '';
    }
    private decodeHTML(encodedHtml: string): string {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = encodedHtml;
        return textarea.value;
    }
}
